import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import GenericPage from "./pages/GenericPage";
import { Toaster } from "./components/ui/toaster";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hakkimizda/kurumsal-yapimiz" element={<Navigate to="/hakkimizda" replace />} />
          <Route path="/hakkimizda/yonetim-kurulu" element={<Navigate to="/hakkimizda" replace />} />
          <Route path="/hakkimizda/insan-kaynaklari" element={<Navigate to="/hakkimizda" replace />} />
          <Route path="/platformlarimiz/*" element={<Navigate to="/" replace />} />
          <Route path="/arastirma/*" element={<Navigate to="/" replace />} />
          <Route path="/duyurular/*" element={<Navigate to="/" replace />} />
          <Route path="/egitimlerimiz/*" element={<Navigate to="/" replace />} />
          <Route path="*" element={<GenericPage />} />
        </Routes>
        <Footer />
        <CookieBanner />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
